import type { IButtonGroupProps } from './ButtonGroup'

import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { INDENTS } from 'vars/index'
import { Direction, Fluid, JustifyContent } from './interfaces'

type WrapperProps = Omit<IButtonGroupProps, 'wrap'> & {
  buttonWrap?: IButtonGroupProps['wrap']
}

export const Wrapper = styled.div<WrapperProps>`
  width: ${({ fluid, width }) =>
    fluid === Fluid.Horizontal || fluid === Fluid.Both
      ? '100%'
      : width
        ? `${width}%`
        : 'auto'};
  height: ${({ fluid }) =>
    fluid === Fluid.Vertical || fluid === Fluid.Both ? '100%' : 'auto'};
  display: inline-flex;
  flex-direction: ${({ direction }) => direction || Direction.Row};
  justify-content: ${({ justifyContent }) =>
    justifyContent || JustifyContent.FlexStart};
  align-items: flex-start;
  flex-wrap: ${({ buttonWrap }) => (buttonWrap ? 'wrap' : 'nowrap')};
  row-gap: var(${INDENTS.INDENT_20});
  column-gap: ${({ columnGap }) => `var(${columnGap || INDENTS.INDENT_20})`};
  padding: ${({ padding }) => (padding ? `0 var(${padding})` : 0)};
  margin: ${({ margins }) =>
    margins && margins.length > 0
      ? margins.map((item) => `var(${item})`)?.join(' ')
      : 0};
  & > a:empty {
    display: none;
  }
  & ${ButtonSC} {
    max-height: ${({ maxHeight }) => (maxHeight ? `${maxHeight}px` : 'unset')};
  }
`

export const PaymentFormButtonGroupSC = styled.div<
  Pick<IButtonGroupProps, 'columnGap'>
>`
  & > ${Wrapper} {
    & > ${ButtonSC} {
      width: ${({ columnGap = INDENTS.INDENT_20 }) =>
        `calc((100% - var(${columnGap})) / 2)`};
    }
  }
`
